document.addEventListener("DOMContentLoaded", function() {
    const estimator = document.getElementById("shipping-estimator");
    const button = document.querySelector(".shipping-estimator__toggle-button");

    if (estimator && button) {
        estimator.style.display = "block"; // Upewnia się, że element jest widoczny
        button.setAttribute("aria-expanded", "true"); // Ustawia atrybut zgodnie ze stanem otwartym
    }
});

const element = document.querySelector(".jdgm-revs-tab.jdgm-revs-tab");
const hideThreshold = 300; // Próg przewinięcia, po którym element się ukrywa
const mobileBreakpoint = 1024; // Maksymalna szerokość ekranu dla urządzeń mobilnych

window.addEventListener("scroll", function () {
    if (window.innerWidth > mobileBreakpoint) {
        // Jeśli to desktop, element zawsze widoczny
        element.style.opacity = "1";
        element.style.pointerEvents = "auto";
        return;
    }

    if (window.scrollY <= hideThreshold) {
        // Na mobilnych, jeśli użytkownik jest na górze strony – pokaż element
        element.style.opacity = "1";
        element.style.pointerEvents = "auto";
    } else {
        // Na mobilnych, jeśli przewinie więcej niż 100px – ukryj element
        element.style.opacity = "0";
        element.style.pointerEvents = "none";
    }
});